/**
 * 客资录入模态框
 *
 */

const state = {
  kzShowModal: false,

  planFunction: false,

  //shopDropdownData 拍摄地下拉
  shopDropdownData: [],
  shopPlData: [],

  //信息来源
  infoMsgData: [],
  infoPlMsgData: [],
}

const getters = {
  kzShowModal: state => {
    return state.kzShowModal
  },
  shopDropdownData: state => {
    return state.shopDropdownData
  },
  infoMsgData: state => {
    return state.infoMsgData
  },
  infoPlMsgData: state => {
    return state.infoPlMsgData
  },
  planFunction: state => {
    return state.planFunction
  },
  shopPlData: state => {
    return state.shopPlData
  }
}

const mutations = {
  setKzModal(state, data) {
    state.kzShowModal = data
  },
  sethopDropdownData(state, data) {
    state.shopDropdownData = data
  },
  setShopPlData(state, data) {
    state.shopPlData = data
  },
  setInfoMsgData(state, data) {
    state.infoMsgData = data
  },
  setInfoPlMsgData(state, data) {
    state.infoPlMsgData = data
  },
  setPlanFunction(state, data) {
    state.planFunction = data
  },
  setClearMsgData(state) {
    state.infoMsgData = []
    state.infoPlMsgData = []
  },
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modelState/kz-entry.js